import React, { useEffect, useState } from "react";
import delete_icon from "../../assets/profile/delete.png";
const Wishlist = () => {
  const [wishListItems, setWishListItems] = useState([]);

  useEffect(() => {
    const wishlistitems = localStorage.getItem("wishlistitems");
    if (wishlistitems) {
      setWishListItems(JSON.parse(wishlistitems));
    }
    console.log(
      "Wish List items from localStorage:",
      JSON.parse(wishlistitems),
    );
  }, []);

  return (
    <div className="">
      <h2 className="bg-white sm:py-2 py-4 px-6  rounded-[10px] font-semibold font-lexend sm:text-center sm:text-base text-xl">
        {wishListItems.length} item(s) added to wishlist
      </h2>
      {wishListItems.length > 0 ? (
        <div className=" font-lexend gap-5 mt-4">
          {wishListItems.map((item) => (
            <div
              key={item.id}
              className="flex sm:flex-col flex-row gap-4 sm:mb-0 mb-4 bg-white p-4 rounded-[10px]"
            >
              <div>
                <img
                  src={item.image}
                  className="w-40 h-40 sm:w-auto sm:h-auto rounded-[10px]"
                  alt=""
                />
              </div>

              <div className=" ">
                <h2 className="xs:text-base text-xl md:text-2xl font-semibold">
                  {item.name}
                </h2>
                <p className="sm:text-sm text-lg text-[#6d6d6d] font-semibold">
                  <span>
                    {item.size} {item.dimension}
                  </span>
                </p>
                <p className="xs:text-xl text-2xl font-semibold mt-1 font-lexend">
                  <span className="line-through xs:text-sm text-[#b1b1b1]">
                    {item.originalPrice}
                  </span>{" "}
                  <span className="text-[#2a552f] xs:text-base">
                    {item.price}
                  </span>
                </p>
                <div className=" flex  flex-row gap-4 sm:mt-2 mt-5">
                  <button className="bg-[#2a552f] text-[#f4e390] xs:text-base text-lg font-lexend py-2  px-6 rounded-lg">
                    Move to cart
                  </button>
                  <button className="bg-[#eaeaea] flex flex-row justify-center items-center gap-1.5 text-[#000000]  text-lg font-lexend py-2 sm:px-4  px-6 rounded-lg">
                    <img src={delete_icon} alt="" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex justify-center items-center  text-center font-semibold w-full xl:h-80 md:h-52 h-32 text-[#333333] font-lexend sm:text-sm text-xl">
          You have not added any item(s) to wishlist yet
        </div>
      )}
    </div>
  );
};

export default Wishlist;
